import { useParams } from "react-router-dom"
import AppRedirectScreen from "../components/AppRedirectScreen"

function SpaceScreen() {
  const { id } = useParams()

  return <AppRedirectScreen type="space" deepLink={`pepchat://space/${id}`} />
}

export default SpaceScreen
